import { useEffect, useState } from 'react';
import { requestJSON, requestBlob } from '../lib/request';
import { loadPhotoImage } from './loadPhotoImage';

export function useHousePhoto(photoId) {
  const [photo, setPhoto] = useState(null), [loading, setLoading] = useState(false), [error, setError] = useState('');
  const [reload, setReload] = useState(0);
  useEffect(() => {
    const controller = new AbortController(); let objectUrl;
    setPhoto(null); setError(''); setLoading(!!photoId);
    if (!photoId) return () => controller.abort();
    const load = async () => {
      try {
        const [record, blob] = await Promise.all([
          requestJSON(`/photos/${photoId}`, { signal: controller.signal }),
          requestBlob(`/photos/${photoId}/image`, { signal: controller.signal, timeoutMs: 60000 }),
        ]);
        if (controller.signal.aborted) return;
        objectUrl = URL.createObjectURL(blob);
        const image = await loadPhotoImage(objectUrl, controller.signal);
        if (!controller.signal.aborted) setPhoto({ ...record, url: objectUrl, image });
      } catch (err) { if (objectUrl) URL.revokeObjectURL(objectUrl); if (!controller.signal.aborted) setError(err.message); }
      finally { if (!controller.signal.aborted) setLoading(false); }
    };
    load(); return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [photoId, reload]);
  return { photo, loading, error, retry: () => setReload(value => value + 1) };
}